export { default } from './Window';
